export default function formatBytes(bytes: number, decimals = 0): string {
  if (bytes === 0) {
    return '0B';
  }

  const kilobit = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];

  const exponent = Math.floor(Math.log(bytes) / Math.log(kilobit));

  return `${parseFloat((bytes / kilobit ** exponent).toFixed(decimals))}${
    sizes[exponent]
  }`;
}
